var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Salaires") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Bulletin de paie et contrepartie monetaire.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 169.8 L 450.3 285.3 L 261.7 394.2 L 61.7 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 196.2,
    x2: 107.4,
    y2: 272.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 280.3,
    y1: 220.1,
    x2: 148.8,
    y2: 296
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 321.7,
    y1: 244.1,
    x2: 190.3,
    y2: 319.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 363.2,
    y1: 268,
    x2: 231.7,
    y2: 343.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 404.6,
    y1: 291.9,
    x2: 273.1,
    y2: 367.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 196.2,
    x2: 404.6,
    y2: 291.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 195,
    y1: 221.5,
    x2: 360.8,
    y2: 317.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 151.2,
    y1: 246.8,
    x2: 317,
    y2: 342.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 107.4,
    y1: 272.1,
    x2: 273.1,
    y2: 367.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 298.9 243.4 L 207.4 296.2 L 207.4 303.4 L 298.9 250.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 133.1 253.3 L 207.4 296.2 L 207.4 303.4 L 133.1 260.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 224.6 200.5 L 298.9 243.4 L 207.4 296.2 L 133.1 253.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 224.6 200.5 L 298.9 243.4 L 207.4 296.2 L 133.1 253.3 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 298.9,
    y1: 243.4,
    x2: 298.9,
    y2: 250.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 207.4,
    y1: 296.2,
    x2: 207.4,
    y2: 303.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 133.1,
    y1: 253.3,
    x2: 133.1,
    y2: 260.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 298.9,
    y1: 250.7,
    x2: 207.4,
    y2: 303.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 207.4,
    y1: 303.4,
    x2: 133.1,
    y2: 260.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "drift d3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 224.6 158.2 L 290.3 196.2 L 198.8 249 L 133.1 211.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 224.6 158.2 L 290.3 196.2 L 198.8 249 L 133.1 211.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 221.7,
    y1: 169.5,
    x2: 254.6,
    y2: 188.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 261.7,
    y1: 192.6,
    x2: 271.7,
    y2: 198.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 204,
    y1: 179.7,
    x2: 236.9,
    y2: 198.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 244,
    y1: 202.8,
    x2: 254,
    y2: 208.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 186.3,
    y1: 189.9,
    x2: 219.1,
    y2: 208.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 226.3,
    y1: 213,
    x2: 236.3,
    y2: 218.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 168.5,
    y1: 200.2,
    x2: 201.4,
    y2: 219.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 208.6,
    y1: 223.3,
    x2: 218.6,
    y2: 229
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 150.8,
    y1: 210.4,
    x2: 183.7,
    y2: 229.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 190.8,
    y1: 233.5,
    x2: 200.8,
    y2: 239.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 253.1 318.3 L 253.1 328.2 A 31.4 18.2 0 0 0 316 328.2 L 316 318.3 A 31.4 18.2 0 0 1 253.1 318.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 253.1 318.3 L 253.1 328.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 316 318.3 L 316 328.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    fill: "none",
    d: "M 253.1 328.2 A 31.4 18.2 0 0 0 316 328.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 284.6,
    cy: 318.3,
    rx: 31.4,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e2",
    fill: "none",
    cx: 284.6,
    cy: 318.3,
    rx: 31.4,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 253.1 307.1 L 253.1 317 A 31.4 18.2 0 0 0 316 317 L 316 307.1 A 31.4 18.2 0 0 1 253.1 307.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 253.1 307.1 L 253.1 317"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 316 307.1 L 316 317"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    fill: "none",
    d: "M 253.1 317 A 31.4 18.2 0 0 0 316 317"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 284.6,
    cy: 307.1,
    rx: 31.4,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e2",
    fill: "none",
    cx: 284.6,
    cy: 307.1,
    rx: 31.4,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 253.1 295.9 L 253.1 305.8 A 31.4 18.2 0 0 0 316 305.8 L 316 295.9 A 31.4 18.2 0 0 1 253.1 295.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 253.1 295.9 L 253.1 305.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 316 295.9 L 316 305.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    d: "M 253.1 305.8 A 31.4 18.2 0 0 0 316 305.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 284.6,
    cy: 295.9,
    rx: 31.4,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    fill: "none",
    cx: 284.6,
    cy: 295.9,
    rx: 31.4,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "a flow",
    d: "M 261.7 202.8 L 276 217.7 L 284.6 272.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d2",
    cx: 276,
    cy: 217.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 276,
    cy: 217.7,
    r: 3.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.6bce20e3f7536a29838b194b12339923.svg";
export { ForwardRef as ReactComponent };